/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { filterPresenterConfig } from './filterPresenterConfig';
import { FilterPresenterType } from '../components/presenters/types';

export function getFilterPresenterType(cellPresenterType: string): null | FilterPresenterType {
  if (!filterPresenterConfig[cellPresenterType]) {
    // TODO: TEMP remove and throw error instead
    // eslint-disable-next-line no-console
    console.error(`Unable to find filter presenter for cell presenter type: ${cellPresenterType}`);
    return null;
  }

  return filterPresenterConfig[cellPresenterType];
}
